<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-one-surtees-the-miner">
<h1 class="main">Part One<br/> Surtees the Miner</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5187d358